module.exports = __webpack_public_path__ + "assets/icons/on-my-way-emoji.gif";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/emojies/on-my-way-emoji.gif
// module id = ./src/styles/icons/emojies/on-my-way-emoji.gif
// module chunks = 0